import React from "react";
import { Navigate } from "react-router-dom";

// Custom hook to use the authentication context
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth(); // Get the authentication state from the context

  // Check if the user is authenticated by checking sessionStorage directly
  const token = sessionStorage.getItem("authToken");

  // If no token is found, the user is not authenticated, so redirect to login page
  if (!isAuthenticated && !token) {
    return <Navigate to="/" replace />; // Redirect to login page
  }

  return children; // Render protected content if authenticated
};

export default ProtectedRoute;
